import {http} from '@/http'

export default {
  list(data, params) {
    return http.post('/api/v1/coupons/list', data, {params})
  },
  save(data) {
    return http.post('/api/v1/coupons', data)
  },
  get(id) {
    return http.get(`/api/v1/coupons/${id}`)
  },
  update(id, data) {
    return http.put(`/api/v1/coupons/${id}`, data)
  },
  changeStatus(id, active) {
    return http.put(`/api/v1/coupons/${id}/status`, null, {
      params: { active },
    })
  },
  remove(id) {
    return http.delete(`/api/v1/coupons/${id}`)
  },
  validate(code, amount) {
    return http.get('/api/v1/coupons/validate', {
      params: { code, amount }
    })
  }
}
